import { createAction } from '@/utility/actions';

import { DICTIONARY_GET } from './_types.ts';

export const getDictionary = createAction(DICTIONARY_GET);

export default {
  getDictionary,
};
